/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import PropTypes from 'prop-types';
import React from 'react';
import './ShowHidePassword.scss';
import TextField from './TextField';
import t from '../i18n/locale-keys';

export default class ShowHidePassword extends React.PureComponent {
    state = {
        passwordVisible: false
    };

    showHidePassword = () => {
        this.setState({
            passwordVisible: !this.state.passwordVisible
        });
    };

    render() {
        const {autoFocus, disabled, label, name, onChange, placeholder, value} = this.props;

        if (disabled) {
            return (
                <TextField
                    autoComplete={'new-password'}
                    disabled
                    id={this.props.id}
                    label={label}
                    placeholder={placeholder}
                    value="*****"
                />
            );
        }

        const id = this.props.id || name;
        const {passwordVisible} = this.state;
        const labelElement = label ? <label htmlFor={id}>{label}</label> : null;
        const passwordInputType = passwordVisible ? 'text' : 'password';
        const buttonStyle = passwordVisible ? {color: 'red'} : null;
        const buttonIcon = passwordVisible ? 'unlock_thick' : 'lock_thick';

        return (
            <div className="ias-input-container show-hide-password">
                {labelElement}
                <input
                    autoComplete={'new-password'}
                    autoFocus={autoFocus}
                    id={id}
                    name={name}
                    onChange={onChange}
                    placeholder={placeholder}
                    type={passwordInputType}
                    value={value}
                />
                <button
                    className="ias-button ias-icon-button"
                    disabled={!value}
                    id={id + '_ShowHide'}
                    title={t.showHidePasswordLabel()}
                    onClick={this.showHidePassword}
                    style={buttonStyle}
                    tabIndex={-1}
                    type="button"
                >
                    <i className={'ias-icon ias-icon-' + buttonIcon} />
                </button>
            </div>
        );
    }
}

ShowHidePassword.defaultProps = {
    autoFocus: false,
    disabled: false,
    placeholder: ''
};

ShowHidePassword.propTypes = {
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired
};
